import { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import usePaymentMethod from '../../../../purchasebills/hooks/usePaymentMethod';
import { toast } from 'react-toastify';
import tooltipIcon from '../../../../../assets/image/tooltip_vendor name.png';
import { getCustomerList } from '../../../../../services/customers';
import CustomDrawer from '../../../components/customDrawer';
import AddPaymentMethodModal from '../../../../purchasebills/components/AddPaymentMethodModal';
import AddCustomerModel from '../../invoice/components/addCustomerModel';
import InputSelect from '../../../../../component/inputSelect/InputSelect';
import InputField from '../../../../../component/form/FormInput';
import { getCurrentDate, getDate } from '../../../../../utils/dateUtils';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import {
	fetchCustomerInvoice,
	fetchPaymentReceivedDetails,
	fetchPaymentReceivedNumber,
} from '../../../../../services/payments_received';
import { format } from 'date-fns';
import PaymentReceivedTable from '../components/paymentReceivedTable';
import { parseISO } from 'date-fns';

const PaymentReceivedForm = ({
	paymentReceived,
	error,
	setError,
	setPaymentReceived,
	setPaymentReceivedTable,
	paymentsReceivedTable,
	setTableError,
	calculateTotalPayment,
	tableError,
}) => {
	const location = useLocation();
	const param = useParams();
	const id = param?.id;
	const [depositToList, setDepositToList] = useState([{ key: 1, value: 'Sales' }]);
	const [customerList, setCustomerList] = useState([]);
	const { paymentMethodList, setSearchPaymentMethod } = usePaymentMethod();
	const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
	const [isAddPaymentMethod, setIsAddPaymentMethod] = useState(false);
	const [isPaymentMethodFocus, setIsPaymentMethodFocus] = useState(false);
	const [searchCustomer, setSearchCustomer] = useState(false);
	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [isDateFocus, setIsDateFocus] = useState(false);
	const [drawerType, setDrawerType] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [autofocus, setAutofocus] = useState(false);
	const [params, setParams] = useState({
		customer: {
			status: 1,
			page: 1,
			pageSize: 10000,
			dropdown: true,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
		},
		doctor: {
			status: 1,
			page: 1,
			pageSize: 10,
			dropdown: true,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
		},
	});
	const handleFormData = (type, value) => {
		setPaymentReceived((prev) => ({
			...prev,
			[type]: value,
		}));

		let newError = { ...error };
		if (type === 'customer_id') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please select valid  customer name from the list';
			} else {
				delete newError[type];
			}
		}

		if (type === 'payment_method') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please select valid  payment method from the list';
			} else {
				delete newError[type];
			}
		}
		if (type === 'received_payment_amount') {
			if (value === '' || value === null || value === undefined) {
				newError[type] = 'Please enter amount received in the field';
			} else {
				delete newError[type];
			}
		}
		setError(newError);
	};

	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsPaymentMethodFocus(true);
	};

	const cancelUsedPastDate = () => {
		setPaymentReceived((prev) => ({
			...prev,
			date: getCurrentDate(),
		}));
		setIsOpenPastDate(false);
		setIsDateFocus(true);
	};

	const handleFetchCustomerList = useCallback(async () => {
		try {
			const { customers } = await getCustomerList(params?.customer);
			const customerOptionList = customers?.map((customer) => {
				return {
					key: customer?.id,
					value: customer?.name,
				};
			});
			setCustomerList(customerOptionList);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}, [params?.customer]);

	useEffect(() => {
		let timer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				customer: {
					...prev.customer,
					filterBy: 'name',
					filterValue: searchCustomer,
					status: 1,
				},
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [searchCustomer]);

	useEffect(() => {
		if (!paymentReceived.customer_id) {
			handleFetchCustomerList();
		}
	}, [params.customer, id, paymentReceived.customer_id]);
	async function handleFetchInvoiceNumber() {
		try {
			const pr = await fetchPaymentReceivedNumber();
			handleFormData('payment_receive_number', pr?.number);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	const handlePaymentChange = (index, value) => {
		const paymentBillsData = [...paymentsReceivedTable];
		paymentBillsData[index].payment_amount = value;
		setPaymentReceivedTable(paymentBillsData);
		const isValid = Number(paymentBillsData[index].due_amount) >= Number(value);
		setTableError((prev) => {
			const filtered = prev.filter((error) => error.index !== index);

			return isValid ? filtered : [...filtered, { index, error: 'Invalid Payment' }];
		});
	};
	const handleFullPaymentToggle = (index, type) => {
		if (type === 'pay') {
			if (Number(paymentReceived.received_payment_amount || 0) > 0) {
				const paymentAmount = paymentsReceivedTable?.reduce(
					(total, bill) => Number(total) + Number(bill.payment_amount),
					0,
				);
				if (
					Number(paymentReceived.received_payment_amount) - Number(paymentAmount) >
					Number(paymentsReceivedTable[index].due_amount)
				) {
					const paymentBillsData = [...paymentsReceivedTable];
					paymentBillsData[index].payment_amount = paymentBillsData[index].due_amount;
					setPaymentReceivedTable(paymentBillsData);
				} else {
					const paymentBillsData = [...paymentsReceivedTable];
					paymentBillsData[index].payment_amount =
						Number(paymentReceived.received_payment_amount) - Number(paymentAmount);
					setPaymentReceivedTable(paymentBillsData);
				}
			} else {
				var newError = { ...error };
				newError.received_payment_amount = 'Please enter payment received amount in the field';
				setError(newError);
			}
		} else {
			const paymentBillsData = [...paymentsReceivedTable];
			paymentBillsData[index].payment_amount = 0.0;
			setPaymentReceivedTable(paymentBillsData);
		}
	};
	function handleClearAppliedAmount() {
		const paymentBillsData = paymentsReceivedTable.map((item) => ({
			...item,
			payment_amount: '',
		}));
		setPaymentReceivedTable(paymentBillsData);
	}

	async function getCustomerInvoices() {
		try {
			var { invoices } = await fetchCustomerInvoice(paymentReceived?.customer_id);
			const customerInvoiceList = invoices.map((invoice) => {
				return {
					id: invoice?.id,
					invoice_number: invoice?.invoice_number,
					due_amount: invoice?.due_amount,
					date: invoice?.date,
					due_date: invoice?.due_date,
					amount: invoice?.total_amount,
					payment_amount: '',
				};
			});
			setPaymentReceivedTable(customerInvoiceList);
		} catch (error) {
			toast.error(error.message ?? 'Something went wrong!');
		}
	}

	useEffect(() => {
		if (!id && paymentReceived?.customer_id) {
			getCustomerInvoices();
		}
	}, [paymentReceived?.customer_id]);

	async function getPaymentsReceivedDetails() {
		try {
			const { payment_receive } = await fetchPaymentReceivedDetails({ ids: [id] });
			const {
				customer_id,
				payment_receive_number,
				cash_handed,
				date,
				deposit_to_id,
				notes,
				payment_mode_id,
				customer,
				sales_payment_receives_invoices,
			} = payment_receive;

			setPaymentReceived((prev) => ({
				customer_id: customer_id,
				payment_receive_number: payment_receive_number,
				date: format(parseISO(date), 'yyyy-MM-dd'),
				received_payment_amount: cash_handed,
				deposit_to_id: deposit_to_id,
				notes: notes,
				payment_method: payment_mode_id,
			}));
			setSearchCustomer(customer?.name);
			const paymentReceivedInvoiceList = sales_payment_receives_invoices?.map((pr) => {
				return {
					id: pr?.invoice?.id,
					invoice_number: pr?.invoice?.invoice_number,
					due_amount: pr?.invoice.due_amount,
					date: pr?.invoice?.date,
					due_date: pr?.invoice?.due_date,
					amount: pr?.invoice_amount,
					payment_amount: pr?.invoice_payment_amount,
				};
			});
			setPaymentReceivedTable(paymentReceivedInvoiceList);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	}

	useEffect(() => {
		if (!id) {
			handleFetchInvoiceNumber();
		} else {
			getPaymentsReceivedDetails();
		}
	}, [id]);

	function setCustomerData() {
		if (location && location?.state) {
			const state = location?.state;
			setCustomerList([state]);
			setPaymentReceived((prev) => ({
				...prev,
				customer_id: state?.key,
			}));
		}
	}

	useEffect(() => {
		if (location && location?.state) {
			setCustomerData();
		}
	}, [location]);

	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	return (
		<div>
			<div
				className="max-w-1297"
				style={{ padding: '1rem 2rem 0' }}
			>
				<div className="row">
					<div className="col-6">
						<InputSelect
							options={customerList}
							label="Customer Name"
							placeholder="Customer Name"
							autoComplete="off"
							required={true}
							returnInputValue={false}
							value={paymentReceived?.customer_id}
							onSelect={(option) => {
								handleFormData('customer_id', option.key);
							}}
							onChange={(value) => {
								if (value === '' || value === null) {
									handleFormData('customer_id', value);
								}
								setSearchCustomer(value);
							}}
							error={error?.customer_id}
							autoFocus={autofocus}
							leftIcons={
								paymentReceived?.customer_id
									? [
											{
												src: tooltipIcon,
												alt: 'Show Customer Details',
												onClick: () => {
													setDrawerType('customer');
													setIsDrawerOpen(true);
												},
											},
										]
									: []
							}
							onAddNew={() => {
								setIsAddCustomerModalOpen(true);
							}}
						/>
					</div>

					<div className="col-2">
						<InputField
							label="Payment #"
							placeholder="PR-0001"
							autoComplete="off"
							type="text"
							required={true}
							disabled={true}
							error={error?.payment_receive_number}
							value={paymentReceived.payment_receive_number}
							onChange={(value) => {
								handleFormData('payment_receive_number', value);
							}}
						/>
					</div>
					<div className="col-2">
						<InputField
							label="Payment Date"
							placeholder="Enter Date"
							type="date"
							required={true}
							error={error?.date}
							autoComplete="off"
							autoFocus={isDateFocus}
							value={paymentReceived.date}
							onBlur={(e) => {
								var value = e.target.value;
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									if (!isUsedPastDate) {
										setIsOpenPastDate(true);
									}

									setPaymentReceived((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setPaymentReceived((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									setPaymentReceived((prev) => ({
										...prev,
										date: value,
									}));
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
								}
							}}
							onChange={(value) => {
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									setPaymentReceived((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									setIsOpenPastDate(false);
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setPaymentReceived((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									setPaymentReceived((prev) => ({
										...prev,
										date: value,
									}));
									setIsOpenPastDate(false);
									delete newError.date;
									setError(newError);
								}
							}}
							max={getCurrentDate()}
						/>
					</div>
					<div className="col-2">
						<InputSelect
							options={paymentMethodList}
							label="Payment Mode"
							placeholder="Payment Mode"
							required={true}
							autoComplete="off"
							autoFocus={isPaymentMethodFocus}
							value={paymentReceived.payment_method}
							onChange={(value) => {
								if (value === '' || value === null) {
									handleFormData('payment_method', value);
								}
								setSearchPaymentMethod(value);
							}}
							onSelect={(options) => {
								handleFormData('payment_method', options?.key);
							}}
							error={error?.payment_method}
							onAddNew={() => {
								setIsAddPaymentMethod(true);
								setIsPaymentMethodFocus(false);
							}}
						/>
					</div>
				</div>
				<div
					className="row"
					style={{ marginTop: '2rem' }}
				>
					<div className="col-3">
						<InputField
							label="Amount Received"
							placeholder="0.00"
							type="text"
							required={true}
							autoComplete="off"
							disabled={false}
							error={error?.received_payment_amount}
							value={paymentReceived.received_payment_amount}
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9.]/g, '');
								handleFormData('received_payment_amount', value);
							}}
						/>
					</div>
					<div className="col-4">
						<InputSelect
							options={depositToList}
							label="deposit To #"
							placeholder="Select Deposit To"
							autoComplete="off"
							required={false}
							disabled={true}
							returnInputValue={false}
							value={paymentReceived?.deposit_to_id}
							onSelect={(option) => {}}
							error={error?.deposit_to_id}
						/>
					</div>
					<div className="col-5">
						<InputField
							label="Notes/Reference#"
							placeholder="Ref-000005"
							type="text"
							required={false}
							autoComplete="off"
							autoFocus={false}
							error={error?.notes}
							value={paymentReceived.notes}
							onChange={(value) => {
								handleFormData('notes', value);
							}}
						/>
					</div>
				</div>
				<PaymentReceivedTable
					isDisabled={false}
					tableColumns={['Date', 'Invoice Number', 'Invoice Amount', 'Amount Due', 'Payment']}
					handleClearAppliedAmount={handleClearAppliedAmount}
					errors={tableError}
					productTableData={paymentsReceivedTable}
					handlePaymentChange={handlePaymentChange}
					handleFullPaymentToggle={handleFullPaymentToggle}
					calculateTotalPayment={calculateTotalPayment}
					type={'pr'}
				/>
			</div>

			{isOpenPastDate && (
				<Modal
					className="delivery-modal"
					title="Confirm Past Date"
					autoComplete="off"
					isOpen={isOpenPastDate}
					onClose={() => cancelUsedPastDate()}
					cancelButton={true}
				>
					<p>You are creating a transaction in the past date. Do you want to continue?</p>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							marginTop: '20px',
						}}
					>
						<Button
							button="Proceed"
							type="button"
							className="btn btn-primary"
							onClick={confirmUsedPastDate}
						/>
						<span style={{ width: '20px' }}></span>
						<Button
							button="Cancel"
							type="button"
							className="btn btn-danger"
							onClick={() => cancelUsedPastDate()}
						/>
					</div>
				</Modal>
			)}

			{isAddCustomerModalOpen && (
				<AddCustomerModel
					setIsAddCustomerModalOpen={setIsAddCustomerModalOpen}
					isAddCustomerModalOpen={isAddCustomerModalOpen}
					setInvoice={setPaymentReceived}
					setCustomerList={setCustomerList}
				/>
			)}

			{isAddPaymentMethod && (
				<AddPaymentMethodModal
					type={'Payment Received'}
					paymentMethodList={paymentMethodList}
					isAddPaymentMethod={isAddPaymentMethod}
					setIsAddPaymentMethod={setIsAddPaymentMethod}
					setIsPaymentMethodFocus={setIsPaymentMethodFocus}
					setPurchaseBillFormData={setPaymentReceived}
				/>
			)}
			{
				<CustomDrawer
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={drawerType === 'customer' ? paymentReceived.customer_id : null}
					drawerType={drawerType}
					activeDrawer={'Details'}
				/>
			}
		</div>
	);
};
export default PaymentReceivedForm;
